export const RESULT_STATUS = {
    Success: 0,
    Error: 1
};

export function getErrorResult(results) {
    const errorResults = results.filter(function (result) {
        return result.Status === RESULT_STATUS.Error;
    });

    if (errorResults && errorResults.length > 0) {
        const message = errorResults
            .map(function (er) {
                return er.Message;
            })
            .join("; ");
        return {
            Status: RESULT_STATUS.Error,
            Message: message
        };
    }

    return null;
}
